import '@zebra-fed/icons/Enterprise/index.css';
import Snackbar from '@material-ui/core/Snackbar';
import { Button, Icon } from '@zebra-fed/zds-react-desktop';
import MaterialTable from 'material-table';
import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { AuthContext } from '../../../authentication/Auth';
import app from '../../../authentication/firebaseStart';
import AddUserModal from '../../../components/modals/AddUserModal';
import ChangePasswordModal from '../../../components/modals/ChangePasswordModal';
import ConfirmModal from '../../../components/modals/ConfirmModal';
import firebaseUtil from '../../../data/FirebaseUtil';
import { ContentWrapper, PageTitle, SnackbarContent } from '../../../styled-components/shared';
import Pagination from './components/Pagination';
import { tableIcons } from './components/TableIcons';
import Toolbar from './components/Toolbar';
import Moment from 'react-moment';
import moment from 'moment';
import config from '../../../data/application.properties'
import BottomNavLinks from "../../../components/BottomNavLinks";
import { Link } from "react-router-dom";
import { DataContext } from '../../../data/DataContext';
import '../../css/reports.css';
import { userJustManager } from '../../../data/userUtil';
import {useTranslation} from "react-i18next";
const firestore = app.firestore();

const MainContent = styled.div`
  border-top: 2px solid #e1e1e1;
  borer-bottom: none;
  border: 1px solid #bdbdbd;
`;

const StyledHeader = styled(PageTitle)`
  // min-width: 1020px;
`;

const TableHeader = styled.h1`
  font-size: 20px;
`;

var searchparam =  {
  fromDate : moment().valueOf(),
  toDate:  moment().valueOf(),
  siteName: ""
}

export default function ManageUsersPage(props) {
  const SUPER_ADMIN = 'superAdmin';
  const DEFAULT_ROWS_PER_PAGE = 100;
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [snackbarVisible, setSnackBarVisible] = useState(false);
  const [snackbarMessage, setSnackBarMessage] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [pageSize, setPageSize] = useState(DEFAULT_ROWS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemCount, setItemCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [deletedUser, setDeletedUser] = useState(null);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [siteName, setSiteName] = useState('');
  const [locations, setLocations] = useState([]);
  const [managerSiteTimeZone, setManagerSiteTimeZone] = useState('');
  // DLR flag
  const { dlrFeatureFlag, mlPredictionStatus } = useContext(DataContext);
  const [showDLR, setShowDLR] = useState(false);

  const context = useContext(AuthContext);
  const modalRef = useRef();
  const addUserModalRef = useRef();
  const confirmModalRef = useRef();
  const {t} = useTranslation();
  const isManager =  userJustManager(context.currentUser.claims)
  const managerSite =- isManager ?  context.currentUser.claims.siteArr[0] : "";

  useEffect(() => {
    const selectedSite = sessionStorage.getItem("selectedSite");
    searchparam.siteName = selectedSite;
    if(isManager && !selectedSite){
      searchparam.siteName = managerSite
    }
    if(selectedSite === 'All Devices'){
      searchparam.siteName = 'All'
    }

    setLoggedInUser(context.currentUser.email);
    getLocations(pageSize);
    getData(pageSize);
    
  }, []);

 
  const getSiteByName = async (managerSite) =>{
    let companyID = context.currentUser.claims.companyID != null ? context.currentUser.claims.companyID : config.TENANT_ID;
    try{
        const siteData = await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('SiteLocations')
          .doc(managerSite)
          .get()
        return siteData.data().timeZone;
    }catch(err){
        console.log("getSiteByName == ",err.message)
        return null;
    }
}

  async function getData(currentPageSize) {
    console.log('searchparam',searchparam);
    console.log("currentPageSize:"+currentPageSize);
    

    //setItemCount(isSuperAdmin === true ? totalCount : totalCount - 1);
    setIsLoading(true);
    let records = [];

    console.log("Search Params",searchparam);
    var params = {
      dateFrom: moment(searchparam.fromDate).format('YYYY-MM-DD'),
      dateTo: moment(searchparam.toDate).format('YYYY-MM-DD'),
      maxResults: 100,
      offset: 0,
    }
    if (searchparam.siteName!=""  && searchparam.siteName!="All"){
      params.siteName = searchparam.siteName;
      setItemCount(1);
    }else{
      getTotalCount(params)
    }
    console.log("Params",params)
    await firebaseUtil
      .getSiteEventData(params)
      .then((response) => {
        console.log("success",response);
        console.log(response.data);
        records=response.data;
      })
      .catch((err) => {
        console.log("Error",err)
      });

    console.log("records",records);
    setIsLoading(false);
    setCurrentPage(0);
    setData(records);
  }

  async function getTotalCount(params){
    let countParms = {"dateFrom":params.dateFrom,"dateTo":params.dateTo}
    await firebaseUtil
    .getSiteEventData(countParms)
    .then((response) => {
      console.log("success",response);
      console.log(response.data);
      const [{totalRows}] = response.data;
      setItemCount(totalRows);

    })
    .catch((err) => {
      console.log("Error",err)
    });
  }

  async function getLocations(currentPageSize) {
    let companyID = context.currentUser.claims.companyID != null ? context.currentUser.claims.companyID : config.TENANT_ID;
    let siteLocations=[]

    if(isManager){
      context.currentUser.claims.siteArr.forEach(element => {
        siteLocations.push({
          "displaySiteName":element.toUpperCase(),
          "siteName":element.toUpperCase()
        })
      });
    }else{
      siteLocations = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('SiteLocations')
          .orderBy('displaySiteName', 'asc')
          .get()
      ).docs.map((doc) => doc.data());

      siteLocations.unshift( {
        "displaySiteName":"All",
        "siteName":"All"
      } ) 
    }
    setLocations(siteLocations)
    console.log("Got locations ",siteLocations);
  }

  function onModalClose(modalType) {
    if (modalType === 'add user') {
      setError(false);
      setSnackBarMessage('User added successfully');
      getData(pageSize);
    } else {
      setError(false);
      setSnackBarMessage('Password changed successfully');
    }
    setSnackBarVisible(true);
  }

  async function next() {
    console.log("Next cp:"+currentPage);
    let itemsPerPage = pageSize;
    //let startDoc = data[data.length - 1].reportedAt;
    //let companyID = context.currentUser.claims.companyID != null ? context.currentUser.claims.companyID : config.TENANT_ID;
    
    //let isSuperAdmin = context.currentUser.claims.isSuperAdmin;

    setIsLoading(true);
    let tabledata = [];
    var params = {
      dateFrom: moment(searchparam.fromDate).format('YYYY-MM-DD'),
      dateTo: moment(searchparam.toDate).format('YYYY-MM-DD'),
      maxResults: itemsPerPage,
      offset: currentPage+1,
    }
    if (searchparam.siteName!=""  && searchparam.siteName!="All"){
      params.siteName = searchparam.siteName;
    }
    console.log("Params",params)
    await firebaseUtil
      .getSiteEventData(params)
      .then((response) => {
        console.log("success",response);
        console.log(response.data);
        tabledata=response.data;
        //setItemCount(tabledata.length);
      })
      .catch((err) => {
        console.log("Error",err)
      });


    setIsLoading(false);
    setData(tabledata);
    setCurrentPage(currentPage + 1);
  }

  async function prev() {
    console.log("Prev cp:"+currentPage);
    let itemsPerPage = pageSize; /* Should be fetched dynamically from UI */
    //let startDoc = data[0].reportedAt; /* First user emailId from the current users list */
    //let companyID = context.currentUser.claims.companyID != null ? context.currentUser.claims.companyID : config.TENANT_ID;
    
    //let isSuperAdmin = context.currentUser.claims.isSuperAdmin;

    setIsLoading(true);
    let tabledata = [];
    var params = {
      dateFrom: moment(searchparam.fromDate).format('YYYY-MM-DD'),
      dateTo: moment(searchparam.toDate).format('YYYY-MM-DD'),
      maxResults: itemsPerPage,
      offset: currentPage-1,
    }
    if (searchparam.siteName!=""  && searchparam.siteName!="All"){
      params.siteName = searchparam.siteName;
    }
    console.log("Params",params)
    await firebaseUtil
      .getSiteEventData(params)
      .then((response) => {
        console.log("success",response);
        console.log(response.data);
        tabledata=response.data;
        //setItemCount(tabledata.length);
      })
      .catch((err) => {
        console.log("Error",err)
      });


    setIsLoading(false);
    setData(tabledata);
    setCurrentPage(currentPage - 1);
  }

  function handleDeleteUser(emailId) {
    setIsLoading(true);

    firebaseUtil
      .deleteUser({ email: emailId })
      .then((response) => {
        setError(!response.status);
        setSnackBarVisible(true);
        setSnackBarMessage(response.msg);
        setDeletedUser(null);
        setSearchText('');
        getData(pageSize);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(!err.status);
        setSnackBarVisible(true);
        setSnackBarMessage(err.msg);
        setDeletedUser(null);
        getData(pageSize);
        setIsLoading(false);
      });
  }

  async function searchByEmailId(emailId) {
    try {
      setIsLoading(true);
      let companyID = context.currentUser.claims.companyID != null ? context.currentUser.claims.companyID : config.TENANT_ID;

      let user = (
        await firestore
          .collection('tenants')
          .doc(companyID)
          .collection('Users')
          .where('emailId', '==', emailId.toLowerCase())
          .get()
      ).docs.map((doc) => doc.data());
      setData(user);
      setItemCount(user.length);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setItemCount(0);
      setData([]);
    }
  }

  const columns = [
    { title: <p className='report-table-padding'>{t('report.site')}</p>, field: 'siteName', sorting: false,
      render: rowData => {
        return (
          <span>
            <p className='report-table-padding'>{rowData.siteName}</p>
          </span>
        )
      } 
    },
    // { title: 'Dashboard Views', field: 'dashboardViewEvents', sorting: false },
    { title: t('report.disconnectEvents'), field: 'disconnectEvents', sorting: false ,
      render: rowData => {
        const state = {...searchparam,category:'Disconnected',siteName:rowData.siteName}
        return (<span>
          {
            rowData.disconnectEvents>0?
            <Link to={{pathname:"/reports/site-event" ,state:state }} >{rowData.disconnectEvents}</Link>:
            rowData.disconnectEvents

          }
        </span>
        )
      }
    },
    { title: t('report.atRisk'), field: 'atRiskEvents', sorting: false, hidden: !showDLR,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'At Risk'}
        return (<span>
          {
            rowData.atRiskEvents>0?
            <Link to={{pathname:"/reports/site-event" ,state:state}} >{rowData.atRiskEvents}</Link>:
            rowData.atRiskEvents
          }
        </span>
        )
      }
    },
    { title: t('report.toBeFoundEvents'), field: 'toBeFoundEvents', sorting: false ,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'To Be Found'}
        return (<span>
          {
            rowData.toBeFoundEvents>0?
            <Link to={{pathname:"/reports/summary-by-category" ,state:state}} >{rowData.toBeFoundEvents}</Link>:
            rowData.toBeFoundEvents
          }
        </span>
        )
      }
    },
    { title: t('report.foundEvents'), field: 'foundEvents', sorting: false,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'Found'}
        return (<span>
          {
            rowData.foundEvents > 0?
            <Link to={{pathname:"/reports/summary-by-category" ,state:state}} >{rowData.foundEvents}</Link>:
            rowData.foundEvents
          }
        </span>
        )
      }
    },
    { title: t('report.beingFoundEvents'), field: 'beingFoundEvents', sorting: false ,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'Being Found'}
        return (<span>
          {
            rowData.beingFoundEvents > 0 ?
            <Link to={{pathname:"/reports/site-event" ,state:state}}>{rowData.beingFoundEvents}</Link>:
            rowData.beingFoundEvents
          }
        </span>
        )
      }
    },
    { title: t('report.cannotFind'), field: 'notFoundEvents', sorting: false ,
      render: rowData => {
          const state = {...searchparam,siteName:rowData.siteName,category:'Cannot Find'}
          return (<span>
            {
              rowData.notFoundEvents>0?
              <Link to={{pathname:"/reports/site-event" ,state:state}} >{rowData.notFoundEvents}</Link>:
              rowData.notFoundEvents
            }
          </span>
          )
        }
    },
    { title: t('report.chargingEvents'), field: 'chargingEvents', sorting: false ,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'Charging'}
        return (<span>
          {
            rowData.chargingEvents>0?
            <Link to={{pathname:"/reports/site-event" ,state:state}} >{rowData.chargingEvents}</Link>:
            rowData.chargingEvents
          }
        </span>
        )
      }
    },
    { title: t('report.lowBattery'), field: 'lowBatteryEvents', sorting: false ,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'Low Battery'}
        return (<span>
          {
            rowData.lowBatteryEvents?
            <Link to={{pathname:"/reports/site-event" ,state:state}} >{rowData.lowBatteryEvents}</Link>:
            rowData.lowBatteryEvents
          }
        </span>
        )
      }
    },
    { title: t('report.movedIn'), field: 'movedInEvents', sorting: false ,
        render: rowData => {
          const state = {...searchparam,siteName:rowData.siteName,category:'Moved In'}
          return (<span>
            {  
              rowData.movedInEvents?
              <Link to={{pathname:"/reports/device-movement" ,state:state}} >{rowData.movedInEvents}</Link>:
              rowData.movedInEvents
            }
          </span>
          )
        }
      },
      { title: t('report.movedOut'), field: 'movedOutEvents', sorting: false ,
      render: rowData => {
        const state = {...searchparam,siteName:rowData.siteName,category:'Moved Out'}
        return (<span>
          {
            rowData.movedOutEvents?
            <Link to={{pathname:"/reports/device-movement" ,state:state}} >{rowData.movedOutEvents}</Link>:
            rowData.movedOutEvents
          }
        </span>
        )
      }
    }
  ];

  useEffect(() => {
    if(!dlrFeatureFlag){
      // hiding At Risk if dlr feature is disabled
      setShowDLR(false);
    }
    else{
      if(mlPredictionStatus)  setShowDLR(true);     // showing At Risk if ml prediction enabled
      else  setShowDLR(false);                      // hiding At Risk if ml prediction disabled
    }
  }, [mlPredictionStatus, dlrFeatureFlag]);

  return (
    <>
      <ContentWrapper>
        <StyledHeader>
        {t('report.eventsBySite')}
        </StyledHeader>
        <MainContent>
          <MaterialTable
            columns={columns}
            options={{
              actionsColumnIndex: 2,
              paginationType: 'stepped',
              search: true,
              minBodyHeight: '250px',
              maxBodyHeight: '400px',
              paging: itemCount > DEFAULT_ROWS_PER_PAGE ? true : false,
              pageSize: DEFAULT_ROWS_PER_PAGE,
              pageSizeOptions: [10, 25, 50, 100],
              cspNonce: window.NONCE_ID,
            }}
            icons={tableIcons}
            isLoading={isLoading}
            components={{
              Pagination: (props) => (
                <Pagination
                  {...props}
                  itemCount={itemCount}
                  currentPage={currentPage}
                  onNextClicked={next}
                  onPrevClicked={prev}
                />
              ),
              Toolbar: (props) => (
                <Toolbar
                  searchText={searchText}
                  fromDate={searchparam.fromDate}
                  toDate={searchparam.toDate}
                  managerSiteTimeZone={managerSiteTimeZone}
                  siteName={searchparam.siteName}
                  locations={locations}
                  onFromDateChange={(date) => {
                    if (date != '') {
                      console.log('DateFrom ' + date);
                      searchparam.fromDate = date; //moment(date).format('YYYY-MM-DD');
                      console.log("searchparam.fromDate "+searchparam.fromDate );
                      getData(pageSize);
                    }
                  }}
                  onToDateChange={(date) => {
                    if (date != '') {
                      console.log('DateTo' + date);
                      searchparam.toDate = date; //moment(date).format('YYYY-MM-DD');
                      getData(pageSize);
                    }
                  }}
                  onSiteNameChange={(event) => {
                    if (event.target.value != '') {
                      console.log('SiteName',event.target.value);
                      searchparam.siteName = event.target.value;
                      const selectedSite = searchparam.siteName === 'All'?'All Devices':searchparam.siteName;
                      sessionStorage.setItem("selectedSite",selectedSite);
                      getData(pageSize);
                    }
                  }}                  
                  onSearch={(searchVal) => {
                    if (searchVal != '') {
                      setSearchText(searchVal);
                      console.log('Search ' + searchVal);
                      searchByEmailId(searchVal);
                    }
                  }}
                  onClear={(searchVal) => {
                    console.log('Reset ' + searchVal);
                    setSearchText('');
                    getData(pageSize);
                  }}
                />
              ),
            }}
            localization={{
              body: {
                emptyDataSourceMessage: t('messages.error.err26'),
              },
            }}

            data={data}
          />
        </MainContent>
        <BottomNavLinks />
        <ChangePasswordModal
          modalRef={modalRef}
          currentUser={currentUser}
          onClose={() => onModalClose('change password')}
        />
        <AddUserModal modalRef={addUserModalRef} onClose={() => onModalClose('add user')} />
        <ConfirmModal
          modalRef={confirmModalRef}
          title={'Delete User'}
          message={`${t('report.deleteUserMsg')} ${deletedUser}?`}
          onClose={() => {
            confirmModalRef.current.toggleDialog();
            handleDeleteUser(deletedUser);
          }}
        />
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={snackbarVisible}
          autoHideDuration={5000}
          onClose={() => setSnackBarVisible(false)}
        >
          <SnackbarContent error={error}>{snackbarMessage}</SnackbarContent>
        </Snackbar>
      </ContentWrapper>
    </>
  );
}